module.exports = __webpack_public_path__ + "static/media/1019053.075f10d4.jpg";